
  import { ADDTHIS } from '@/constants/addthis';
  import addthis from 'addthis-snippet';
  import wordsCounter from 'word-counting';

  export default {
    middleware: ['media/guide', 'breadcrumbs', 'jumbotron', 'meta-tags'],
    meta: {
      disableJumbotron: true,
      hasAmp: true
    },
    data () {
      return { timeToRead: null };
    },
    computed: {
      guide () {
        return this.$store.getters['blog/getGuide'];
      },
      tooltipOptions () {
        return {
          popoverBaseClass: 'languageTooltip',
          trigger: 'hover'
        };
      },
      wrappedBody () {
        // Wraps any <table> elements in a div.table-wrapper
        // Makes it easier to style on mobile
        if (this.guide.body === null) return null;
        const wrappedTable = '<div class="table-wrapper">$&</div>';
        const regex = /<table\b[^>]*>[\s\S]*?<\/table>/gi;
        return this.guide.body.replace(regex, wrappedTable);
      }
    },
    mounted () {
      addthis(ADDTHIS.config, ADDTHIS.share);
      this.timeToRead = Math.round(wordsCounter(this.guide.body, { isHtml: true }).wordsCount / 200);
    }
  };
